import type { ReactElement } from 'react'
import { useT } from '../i18n/useI18n'
import type { PriceStatus } from '../data/pricing'
import './PriceStatusBadge.css'

/** A price that is not final yet ('indicative' or 'beta'), wherever the price is shown: its label, and its hint on hover. */
export default function PriceStatusBadge({ status }: { status: PriceStatus }): ReactElement {
  const t = useT()
  return <span className={`sm-price-status sm-price-status--${status}`} title={t(`pricing.priceStatus.${status}.hint`)}>{t(`pricing.priceStatus.${status}.label`)}</span>
}
